export const POSITIVE_DIGITS = /\d+/g;
